// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"fc355b69","156":"54faee66","228":"be00094a","258":"d8b41c22","277":"57c80b05","359":"d636a456","577":"39ec4979"}[chunkId] + ".chunk.js";
};